/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';

import { AppContainer } from '../AppContainer';
import { SignInPage } from './SignInPage';
import { UpdatePasswordChallengePage } from './UpdatePasswordChallengePage';
import { SetupMFAPage } from './SetupMFAPage';
import { PhoneMFAPage } from './PhoneMFAPage';
import { EmailMFAPage } from './EmailMFAPage';
import { ForgotPasswordPage } from './ForgotPasswordPage';
import { PasswordResetEmailPage } from './PasswordResetEmailPage';
import { ResetPasswordPage } from './ResetPasswordPage';
import { SelectPrincipalPage } from './SelectPrincipalPage';
import { CookieMatchedRoute } from './CookieMatchedRoute';

export namespace UnauthenticatedApp {
  export interface Props {}
}

export const UnauthenticatedApp: React.FC<UnauthenticatedApp.Props> = () => {
  return (
    <AppContainer>
      <Switch>
        <CookieMatchedRoute exact path="/client/login">
          <SignInPage />
        </CookieMatchedRoute>
        <CookieMatchedRoute exact path="/client/login/update-password" redirectUrlOnFailedCookie="/client/login">
          <UpdatePasswordChallengePage />
        </CookieMatchedRoute>
        <CookieMatchedRoute exact path="/client/login/setup-mfa" redirectUrlOnFailedCookie="/client/login">
          <SetupMFAPage />
        </CookieMatchedRoute>
        <CookieMatchedRoute exact path="/client/login/sms-mfa" redirectUrlOnFailedCookie="/client/login">
          <PhoneMFAPage />
        </CookieMatchedRoute>
        <CookieMatchedRoute exact path="/client/login/email-mfa" redirectUrlOnFailedCookie="/client/login">
          <EmailMFAPage />
        </CookieMatchedRoute>
        <CookieMatchedRoute exact path="/client/forgot-password">
          <ForgotPasswordPage />
        </CookieMatchedRoute>
        <CookieMatchedRoute exact path="/client/forgot-password/email-sent" redirectUrlOnFailedCookie="/client/login">
          <PasswordResetEmailPage />
        </CookieMatchedRoute>
        <CookieMatchedRoute exact path="/client/login/select-principal" redirectUrlOnFailedCookie="/client/login">
          <SelectPrincipalPage />
        </CookieMatchedRoute>
        <CookieMatchedRoute
          exact
          path="/client/forgot-password/set-new-password"
          redirectUrlOnFailedCookie="/client/login"
        >
          <ResetPasswordPage />
        </CookieMatchedRoute>
        <Route path="*">
          <Redirect
            to={{
              pathname: '/client/login',
              search: window.location.search,
            }}
          />
        </Route>
      </Switch>
    </AppContainer>
  );
};
